import { useAtom, useAtomValue } from 'jotai';
import Link from 'next/link';
import { ArrowRightIcon } from '@heroicons/react/20/solid';
import { useParams } from 'next/navigation';
import {
  nextChapterAtom,
  prevChapterAtom,
} from '../../jotaiStore/chaptersStore';
import {
  isStreamingMapAtom,
  mapDataAtom,
  contentAtom,
  pass1LearningPathAtom,
  pass2LearningPathAtom,
  viewportAtom,
} from '../../jotaiStore';
import { Pass2Sidequest } from '@/typesV2';
import { Pass2Section } from '@/typesV2';
import { Pass2Option } from '@/typesV2';
import { slugify } from '@/lib/map/slugify';

const GetStartedButton = ({
  setIsLoading,
}: {
  setIsLoading?: (isLoading: boolean) => void;
}) => {
  const nextChapterData = useAtomValue(nextChapterAtom);
  const isStreaming = useAtomValue(isStreamingMapAtom);
  const { mapSlug, contentSlug } = useParams();
  const mapData = useAtomValue(mapDataAtom);
  const pass1LearningPath = useAtomValue(pass1LearningPathAtom);
  const pass2LearningPath = useAtomValue(pass2LearningPathAtom);
  const [contentText, setContentText] = useAtom(contentAtom);
  const viewport = useAtomValue(viewportAtom);
  if (isStreaming) {
    return null;
  }

  if (!!contentSlug && contentSlug !== 'overview') {
    return null;
  }

  if (!pass1LearningPath && !pass2LearningPath) return null;

  const firstTopic = pass2LearningPath?.[0] || pass1LearningPath?.[0];
  let firstSubtopic: any;
  firstSubtopic =
    firstTopic?.options?.[0] ||
    firstTopic?.sections?.[0] ||
    firstTopic?.sideQuests?.[0];

  if (!firstSubtopic) return null;

  const subtopicTitle =
    firstSubtopic?.optionTitle ||
    firstSubtopic?.subTopicTitle ||
    firstSubtopic?.sideQuestTitle;

  return (
    <Link
      href={`/map/${mapSlug}/${
        firstSubtopic?.slug || slugify(subtopicTitle)
      }?x=${viewport.x}&y=${viewport.y}&zoom=${viewport.zoom}`}
      className="flex items-center gap-1 self-end bg-colors-green text-shades-base rounded-lg px-4 py-2 font-semibold hover:bg-colors-greenDark transition-colors duration-300 shadow-md"
      onClick={() => {
        setIsLoading && setIsLoading(true);
        setContentText('');
      }}
    >
      {firstSubtopic.optionTitle ||
        firstSubtopic.subTopicTitle ||
        firstSubtopic.sideQuestTitle}
      <ArrowRightIcon className="h-6 w-6 -mr-1 stroke-2 text-shades-baseDark" />
    </Link>
  );
};

export default GetStartedButton;
